(function($) {
    // var excludes = $('.hero h1.title, .homepage-hero h2, .gallery-slider h4, .gallery-slider p');
    //
    // $(".sidebar-navigation,  p, h1, h2, h3, h4, h5, h6, .fade-in-text").not(excludes).each(function () {
    //     //Exclude footer elements
    //     if( !$(this).closest('footer').length ) {
    //         $(this).attr("data-aos", "fade-up");
    //     }
    // });
    //
    // $(window).load(function() {
    //     setTimeout(function() {
    //         AOS.refresh();
    //     }, 300);
    // });
    //
    // $(window).on('load', function(){
    //     AOS.init({
    //         once: true,
    //         offset: 300,
    //         duration: 800,
    //     });
    // });

})( jQuery );